import { STARTED_MATCH, STOPPED_MATCH } from '../matches'
import { CHART_UPDATED } from '../chart'
import { BET_STARTED, QUESTION_ASKED } from '../questionGame/actions'

export const match = (state = null, action) => {
    switch (action.type) {
        case CHART_UPDATED:
            if (!action.match)
                return state
            return {
                ...state,
                ...action.match
            }

        case STARTED_MATCH:
            return {
                ...state,
                ...action.match
            }

        case STOPPED_MATCH:
            return {
                ...state,
                ...action.match
            }
            
        case BET_STARTED:
        case QUESTION_ASKED:
            return {
                ...state,
                currentQuestionIndex: action.currentQuestionIndex || state.currentQuestionIndex
            }

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/match/index.js